import React, { Component } from "react"
import {
    OutstandingTimesheetListMineContainer,
    OutstandingTimesheetListTeamContainer,
    OutstandingTimesheetListAllContainer
} from "components/outstandingTimesheets/redux/OutstandingTimesheetContainers"

export class OutstandingTimesheetPageMine extends Component { render() { return (<OutstandingTimesheetListMineContainer />) } }
export class OutstandingTimesheetPageTeam extends Component { render() { return (<OutstandingTimesheetListTeamContainer />) } }
export class OutstandingTimesheetPageAll extends Component { render() { return (<OutstandingTimesheetListAllContainer />) } }